import React from "react";
import { Box, Dialog, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getDatabase, ref, push, update } from "firebase/database";
import { toast } from "react-toastify";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const TutorialDialogBox = ({ open, onClose, tutorial }) => {
  const isEdit = tutorial && tutorial.id;

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    link: Yup.string().url("Invalid URL").required("Link is required"),
  });

  const formik = useFormik({
    initialValues: {
      title: tutorial.title || "",
      link: tutorial.link || "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const db = getDatabase();

      if (isEdit) {
        const docRef = ref(db, `tutorial/${tutorial.id}`);
        await update(docRef, { link: values.link });
        toast.info("Tutorial updated!", {
          autoClose: 3000,
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        const docRef = ref(db, `tutorial`);
        await push(docRef, values);
        toast.info("Tutorial saved!", {
          autoClose: 3000,
          position: toast.POSITION.TOP_CENTER,
        });
      }

      onClose();
    },
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <IconButton onClick={onClose} sx={{ position: "absolute", right: 20, top: 0 }}>
        <CloseIcon />
      </IconButton>

      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          padding: 4,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          backgroundColor: "#f7f9fc",
        }}
      >
        <TextField
          id="title"
          name="title"
          label="Tutorial Title"
          fullWidth
          disabled={isEdit}
          value={formik.values.title}
          onChange={formik.handleChange}
          error={formik.touched.title && Boolean(formik.errors.title)}
          helperText={formik.touched.title && formik.errors.title}
        />

        <TextField
          id="link"
          name="link"
          label="YouTube Link"
          fullWidth
          value={formik.values.link}
          onChange={formik.handleChange}
          error={formik.touched.link && Boolean(formik.errors.link)}
          helperText={formik.touched.link && formik.errors.link}
        />

        <button type="submit" className="btn btn-success mt-2 ms-3 mb-3" fullWidth>
          {isEdit ? "UPDATE" : "SAVE"}
        </button>
      </Box>
    </Dialog>
  );
};

export default React.memo(TutorialDialogBox);
